{
  "$id": "wealthlane://forms/employee-type/rules",
  "$schema": "wealthlane://schemas/form-rules",
  "effects": [],
  "observers": [],
  "rules": []
}
